var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    author: "Jessica Elmhurst",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581 583.1",
    height: 320,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1272d;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#000;stroke-miterlimit:10;stroke-width:8px;}.cls-2{fill:#c7b299;}.cls-3{fill:#1a1a1a;}.cls-4{fill:#736357;}.cls-5{fill:#534741;}.cls-6{fill:#fff;}.cls-7{fill:#39b54a;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 581,
    height: 581
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180,80c-.36-5.66-2.37-17.12-3.5-19.5-7.58-15.88-25.13-16.69-49-36-3.62-2.93-6.39-5.48-8-7l1.5,39.5c1,11,6.5,12.5,10,15,2.78,1.99,7,3,12.5,6.5,3.18,2.02,5.53,3.96,7,5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "150.5 89.5 104.5 135.5 152.5 136.91 179 101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m444.5,338l-.5-60c31.5,0,39.5-12.54,39.5-28,0-15.46-13-28-39.5-28l-4-5c0-96.65-66.71-175-149-175s-149,78.35-149,175l-4.5,6c-26.5,0-39.5,12.54-39.5,28s8,28,39.5,28l-.5,60c51,20,104.72,24,157,24s98-5,150.08-24l.42-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m415,181c0,44.96-57.78,87-124,87s-124-42.04-124-87,57.78-81.4,124-81.4,124,36.44,124,81.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 238.5,
    cy: 181.5,
    rx: 53.5,
    ry: 47.5,
    transform: "translate(-24.32 325.56) rotate(-66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 250.5,
    cy: 189,
    rx: 11,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m411,108q-3.5-7.5-10.5-16.5c-8-10-10-11-15.5-14.5l-3-.13h-207.5v31.03h232.5l4,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m444.12,482.96l-.42,1c-52.08,19-100,24-150.08,24s-106-4-157-24l.05-144.24c51,20,104.72,24,157,24s98-5,150.08-24l.42-1-.05,144.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 169.5,
    cy: 89.5,
    rx: 20,
    ry: 16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 341.8,
    cy: 181.86,
    rx: 47.5,
    ry: 53.5,
    transform: "translate(-44.42 154.75) rotate(-24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m443.7,546.86v-62.9c-52.08,19-100,24-150.08,24s-106-4-157-24v65.73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 328.5,
    cy: 189,
    rx: 11,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m87,472.5h49.06l1.44-133c-9.63-.84-23.75-.84-28.5.5-6.85,1.93-13.57,3.82-19,10-5.48,6.25-5.5,12.5-5.5,18.5l-1,104h3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m136.5,472.5v40c-3.41.63-23.3,2.89-37.5-6-11.9-7.45-15.5-11.5-15.5-33.5l53-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m287,579c-4-30-11-43-41-43-54.01,0-128,5-155,40l196,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m296,579c4-30,10.73-42,40.73-42,54.01,0,128,5,155,40l-195.73,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.23,535.76c30,0,37,13,41,43l8.77.24c4-30,10.95-42.74,40.95-42.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m493.94,472.83h-49.06s-1.44-133-1.44-133c9.63-.84,23.75-.84,28.5.5,6.85,1.93,13.57,3.82,19,10,5.48,6.25,5.5,12.5,5.5,18.5l1,104h-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m444.44,472.83v40c3.41.63,23.3,2.89,37.5-6,11.9-7.45,15.5-11.5,15.5-33.5l-53-.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaSe);
export default __webpack_public_path__ + "static/media/ninja-se.ae79bc053a3fe7b8e904b62cabf76cc6.svg";
export { ForwardRef as ReactComponent };